import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const token = Cookies.get("swasthya-token");
const user=localStorage.getItem("swasthya-user")

const initialState = {
  user: user||null,
  token: token || null,
  isAuthenticated: !!token,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;

      Cookies.set("swasthya-token", action.payload.token, { expires: 7 });
     
        localStorage.setItem("swasthya-user", JSON.stringify(action.payload.user))
    },

    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;

      Cookies.remove("swasthya-token");
     
       localStorage.removeItem("swasthya-user")
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;